import * as React from "react";
import { BaseEditor } from "./BaseEditor";
import { makeLazyEditor } from "./LazyEditor";

interface SourceEditorProps {
  defaultValue: string | undefined;
  onChange: (value: string | undefined) => void;
}

const SourceEditor = ({ defaultValue, onChange }: SourceEditorProps) => {
  return (
    <BaseEditor
      defaultValue={defaultValue}
      language="json"
      onChange={(newValue) => onChange(newValue)}
      options={{ ariaLabel: "Source" }}
    />
  );
};

const LazySourceEditor = makeLazyEditor(SourceEditor, "json");

export { SourceEditor, LazySourceEditor };
